import { Outlet } from 'react-router-dom';
import { StudentNav } from './StudentNav';
// import { StudentFooter } from './StudentFooter'; // Removed as per request
import { Toast } from '../../components/ui/toast';
import { useStudentState } from '../../hooks/use-student-state';
import { StudentStateContext } from '../../hooks/student-state-context';
import styles from './student-layout.module.css';
import './student-theme.css';


export function StudentLayout() {
  const state = useStudentState();

  return (
    <StudentStateContext.Provider value={state}>
      <div className={`${styles.layout} student-portal-container`}>
        <StudentNav studentName={state.student.name} studentAvatar={state.student.avatar} />
        <main className={styles.content}>
          <Outlet />
        </main>
        {/* <StudentFooter /> */}
        {state.toast && <Toast message={state.toast.message} type={state.toast.type} />}
      </div>
    </StudentStateContext.Provider>
  );
}
